import { render, staticRenderFns } from "./Videostream.vue?vue&type=template&id=5b0f2895&scoped=true&"
import script from "./Videostream.vue?vue&type=script&lang=js&"
export * from "./Videostream.vue?vue&type=script&lang=js&"
import style0 from "./Videostream.vue?vue&type=style&index=0&id=5b0f2895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f2895",
  null
  
)

export default component.exports